import styled from 'styled-components';
import { CurrentTab } from 'src/modules/user/profile/components/currentTab';
import i18n from 'src/utils/translate';
import ProfileAbout from 'src/modules/user/profile/components/profileAbout';
import ProfileNavbar from 'src/modules/user/profile/components/profileNavbar';
import { useMediaQuery } from 'src/utils/mediaQuery';
export default function ProfileContent() {
  const isDesktop = useMediaQuery('overScreenMedium');
  return <Wrapper data-sentry-element="Wrapper" data-sentry-component="ProfileContent" data-sentry-source-file="profileContent.tsx">
      {isDesktop && <DesktopSidebar>
          <SidebarHeader>{i18n.t('About')}</SidebarHeader>
          <ProfileAbout />
        </DesktopSidebar>}
      <TabsContainer data-sentry-element="TabsContainer" data-sentry-source-file="profileContent.tsx">
        <ProfileNavbar data-sentry-element="ProfileNavbar" data-sentry-source-file="profileContent.tsx" />
        <CurrentTab data-sentry-element="CurrentTab" data-sentry-source-file="profileContent.tsx" />
      </TabsContainer>
    </Wrapper>;
}
const Wrapper = styled.div`
  display: flex;
  gap: 40px;
`;
const DesktopSidebar = styled.div`
  flex: 2;
`;
const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  height: 55px;
  border-bottom: ${({
  theme
}) => theme.greyLine};
  margin-bottom: 20px;
`;
const TabsContainer = styled.div`
  flex: 3;
`;